/* APCG · Oferta: selector de pack, barra de compra en celular y pedido directo (v6.6) */
(function () {
  function init(root) {
    if (!root || root.dataset.apcgInit) return;
    root.dataset.apcgInit = '1';
    var form = root.querySelector('[data-of-form]');
    if (!form) return;
    var inputs = [].slice.call(form.querySelectorAll('input[name="id"]'));
    if (!inputs.length) return;
    var ids = inputs.map(function (i) { return i.value; });
    var prices = [].slice.call(root.querySelectorAll('[data-of-price]'));
    var unit = root.querySelector('[data-of-unit]');
    var cta = root.querySelector('[data-of-cta]');
    var sticky = root.querySelector('[data-of-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-of-sticky-btn]') : null;
    var wa = root.querySelector('[data-of-wa]');
    var buttons = [cta, stickyBtn].filter(Boolean);

    function selected() {
      var c = inputs.filter(function (i) { return i.checked; })[0];
      return c || inputs[0];
    }

    function sync() {
      var s = selected();
      if (!s) return;
      [].slice.call(form.querySelectorAll('.apcg-of__pack')).forEach(function (l) {
        l.classList.toggle('is-selected', l.contains(s));
      });
      prices.forEach(function (e) { e.textContent = s.dataset.price; });
      if (unit) unit.textContent = s.dataset.unit || '';
      var ok = s.dataset.available === 'true';
      buttons.forEach(function (b) {
        b.disabled = !ok;
        b.textContent = ok ? b.dataset.label : b.dataset.soldout;
      });
      if (wa) wa.href = wa.dataset.base + encodeURIComponent(wa.dataset.text + ' ' + s.dataset.title);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', s.value);
        window.history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    function order(ev) {
      if (ev) ev.preventDefault();
      var s = selected();
      if (!s || s.dataset.available !== 'true') return;
      buttons.forEach(function (b) { b.disabled = true; b.textContent = b.dataset.loading; });
      var updates = {};
      ids.forEach(function (id) { updates[id] = 0; });
      updates[s.value] = 1;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          var has = (cart.items || []).some(function (it) { return String(it.variant_id) === String(s.value); });
          if (!has) throw new Error('not in cart');
          window.location.href = form.dataset.checkout || '/checkout';
        })
        .catch(function () {
          form.removeEventListener('submit', order);
          form.submit();
        });
    }

    inputs.forEach(function (i) { i.addEventListener('change', sync); });
    form.addEventListener('submit', order);
    if (stickyBtn) stickyBtn.addEventListener('click', order);

    if (sticky && cta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top > 0;
        var above = e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !e.isIntersecting && (below || above));
        sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(cta);
    }
    sync();
  }

  function boot(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-apcg-of]')).forEach(init);
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();